import React, { useCallback, useMemo, useState } from "react";
import Language, { DirectionsEnum } from "../libs/Language";
export const DEFAULT_LANGUAGE = "en";
export const DEFAULT_SUPPORTED_LANGUAGES = [
    {
        abbreviations: "en",
        direction: DirectionsEnum.LTR
    },
    {
        abbreviations: "ar",
        direction: DirectionsEnum.RTL
    }
];
export const DEFAULT_PROPS = {
    languageKey: DEFAULT_LANGUAGE,
    supported_languages: DEFAULT_SUPPORTED_LANGUAGES
};
const LanguageContext = React.createContext({
    language: Language.language,
    updateLanguage: (lang) => {
    },
    translate: (key) => { return ''; }
});
export const LanguageContextProvider = (props = DEFAULT_PROPS) => {
    const [isRefresh, setIsRefresh] = useState(false);
    useMemo(() => {
        const supported_languages = {};
        for (const supportedLanguage of props.supported_languages) {
            supported_languages[supportedLanguage.abbreviations] = supportedLanguage;
        }
        const config = Object.assign({}, props);
        delete config.children;
        Language.init(Object.assign(Object.assign({}, config), { supported_languages }));
    }, [props]);
    const updateLanguageHandler = (lang) => {
        Language.setLanguage(lang);
        setIsRefresh(!isRefresh);
    };
    const locale = useMemo(() => {
        try {
            return require(`../locale/${Language.language.abbreviations.toLowerCase()}.js`).default;
        }
        catch (err) {
            return require(`../locale/${DEFAULT_LANGUAGE.toLowerCase()}.js`).default;
        }
    }, [isRefresh]);
    const translateHandler = useCallback((key, replace) => {
        if (!locale[key])
            return key;
        return locale[key].format(replace);
    }, [locale]);
    return (React.createElement(LanguageContext.Provider, { value: {
            language: Language.language,
            updateLanguage: updateLanguageHandler,
            translate: translateHandler
        } }, props.children));
};
export default LanguageContext;
